import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToggleSharedService {
  private clipboardToggleSubject = new Subject<boolean>();
  clipboardToggle$ = this.clipboardToggleSubject.asObservable();

  toggleClipboardState(isCollapsed: boolean) {
    this.clipboardToggleSubject.next(isCollapsed);
  }
}